export default {
    language: 'es-ES',
    navigation: 'Volver',
    home: {
        title: 'Calculador de Pintura de Nautica',
        subtitle:
            'Ayúdenos a elegir el mejor sistema antiincrustante para su barco y calcule el volumen necesario según sus necesidades',
        findProduct: 'Encontrar producto',
        calculateVolume: 'Calcular el volumen'
    },
    find: {
        questions: {
            type: '<strong>Tipo</strong> de embarcación?',
            material: '<strong>Sustrato</strong> de la embarcación?',
            sailFrequency: '¿Con qué <strong>frecuencia usa</strong> el barco?',
            paintLocation: '<strong>Dónde</strong> pintar su barco?',
            waterType: '¿En qué <strong>tipo de agua</strong> conduces tu bote?'
        },
        answers: {
            help: '¿Necesita más ayuda con su elección de sistema antiicrustante?',

            type: [
                {
                    label: 'Embarcación a vela',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Embarcación a motor',
                    sublabel: 'hasta 20 nudos',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Embarcación a motor',
                    sublabel: 'más rápido que 20 nudos',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'Fibra de vidrio',
                    value: 'plastic'
                },
                {
                    label: 'Hierro',
                    value: 'iron'
                },
                {
                    label: 'Madera',
                    value: 'wood'
                },
                {
                    label: 'Aluminio',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Pocas veces',
                    sublabel: '1-2 veces al mes o menos',
                    value: 'low'
                },
                {
                    label: 'A menudo',
                    sublabel: '1-2 veces por semana',
                    value: 'medium'
                },
                {
                    label: 'Muy a menudo',
                    sublabel: 'Casi todos los días',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Elige país',
                    countries: [
                        { label: 'UK', value: 'en-GB' },
                        { label: 'US', value: 'en-US' },
                        { label: 'Canadá', value: 'en-CA' },
                        { label: 'Dinamarca', value: 'da-DK' },
                        { label: 'España', value: 'es-ES' },
                        { label: 'Finlandia', value: 'fi-FI' },
                        { label: 'Alemania', value: 'de-DE' },
                        { label: 'Grecia', value: 'el-GR' },
                        { label: 'Croacia', value: 'hr-HR' },
                        { label: 'Noruega', value: 'nb-NO' },
                        { label: 'Países Bajos', value: 'nl-NL' },
                        { label: 'Suecia - costa este', value: 'sv-SE_e' },
                        { label: 'Suecia - costa oeste', value: 'sv-SE_w' },
                        { label: 'Suecia - lago', value: 'sv-SE_l' }
                    ]
                }
            ],
            waterType: [
                { label: 'Mar/Oceano', value: 'sea/ocean' },
                { label: 'Río', value: 'rivers' },
                { label: 'Lago', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Nosotros recomendamos',
            selection: {
                title: 'Su elección',
                type: 'Tipo de embarcación',
                waterType: 'Tipo de agua',
                material: 'Sustrato',
                sailFrequency: 'Actividad',
                country: 'País'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Mejor opción',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Mejor opción',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'Descubrir más',
            whereToBuy: 'Dónde comprar',
            email: 'Email',
            send: 'Enviar',
            feedback: {
                title: '¿Le ha resultado útil esta información?',
                yes: 'Sí',
                no: 'No',
                comment: 'Comentario',
                placeholder: 'Comentario'
            },
            recommendation: {
                title: 'Enviar recomendación al correo electrónico'
            },
            calculateVolume: 'Calcular el volumen'
        }
    },
    calculate: {
        letsCalculate: 'Calculemos',
        questions: {
            antifouling: 'Escoja los antiincrustantes',
            keelType: 'Tipo de <strong>quilla</strong>?',
            dimensions: '<strong>Dimensiones</strong> del barco?'
        },
        answers: {
            keelType: [
                {
                    label: 'Quilla fina',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Quilla corrida',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Dimensiones individuales'
                },
                {
                    title: 'O área submarina en m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Unidad',
                    values: [{ label: 'Metros', value: 'm' }, { label: 'Pies', value: 'f' }]
                },
                {
                    type: 'waterline',
                    label: 'Eslora de flotación'
                },
                {
                    type: 'beam',
                    label: 'Manga'
                },
                {
                    type: 'draft',
                    label: 'Calado'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Volumen requerido',
            selection: {
                title: 'Su elección',
                antifouling: 'Antiicrustante',
                type: 'Tipo de embarcación',
                material: 'Sustrato',
                sailFrequency: 'Actividad',
                country: 'Pais',
                keelType: 'Tipo de quilla',
                dimensions: 'Dimensión del barco'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'La mejor compra',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Mejor opción',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Cantidad sugerida',
            suggestedAmountTwoCoats: 'Cantidad sugerida (2 capas)',
            oneCoat: '(1 capa)',
            fiveCoats: '(5 capas)',
            primerAltTiecoatSilic: 'No olvides usar también el primer de conversión.',
            primerAltSilicSealSilic:
                '<strong>CASO 2</strong<br/>Aplicación en un nuevo sistema de casco.',
            primerAlLightSilic:
                '<strong>CASO 1</strong<br/>Aplicación encima del antiguo antideslizante en buen estado.',

            primerAltTiecoat: 'No olvide utilizar siempre el tiecoat!',
            primerAltSilicSeal:
                '<strong>CASO 2</strong<br/>Aplicación sobre el antiguo antiincrustante en buen estado – transición fácil al sistema Silic One',
            primerAlLight:
                '<strong>CASO 1</strong<br/>Eliminación del antiguo antiincrustante y aplicación del sistema completo & embarcación nueva sin epoxi',
            primer:
                '¿<strong> La carrocería </strong> del barco está <strong> muy dañada </strong> o <strong> pinta por primera vez? </strong> Necesitará ...',
            whereToBuy: 'Dónde comprar',
            email: 'Dirección de correo electrónico',
            send: 'Enviar',
            or: 'O',
            feedback: {
                title: '¿Le ha resultado útil esta información?',
                yes: 'Sí',
                no: 'No',
                comment: 'Comentario',
                placeholder: 'Comentario'
            },
            recommendation: {
                title: 'Enviar recomendación al correo electrónico'
            },
            calculateVolume: 'Calcular el volumen'
        }
    },
    map: {
        country: 'País',
        city: 'Ciudad',
        getDirections: 'Conseguir las direcciones',
        placeholder: 'Todas las ciudades...'
    },
    footer: 'Hempel Yacht - Todo lo que necesita saber sobre la pintura para barcos'
}
